import { Injectable } from '@angular/core';
import { WholeHist } from './api-service/hist/whole-hist';
import { UserCache } from './user-cache';
import { NHIRegIC } from './api-service/register/nhiRegIc';
import { ClinicDataService, NumberValueTextPairBundle } from './data-service/clinic-data-service';
import { PatientApi } from './api-service/patient/patient-api';
import { HST001Params } from './api-service/parameters/HST001Params';
import { HcrService } from './hcr-service.service';
import { EasyNotificationService } from './easy-notification.service';
import { SessionService } from './session.service';
import {encode} from 'iconv-lite';
//import * as iconv from 'iconv-lite';
import { RegisterApi, SatelliteLog } from './api-service/register/register-api';
import { JailInfo } from '../hist/rating-price/models/kidneydialysisdto';
import { ClinicSessionApi } from './api-service/clinic/clinic-session-api.service';
import { FunctionEnable } from './base-config.service';
import { OrderDispensingTypeEnum } from '../enums/DispensingTypeEnum';
import { OrderSpecialRuleEnum } from '../enums/OrderSpecialRuleEnum';
import { Subject } from 'rxjs';
import { DebugLogService } from './debug-log.service';
import { SatellitePharmacyXmlBuilder } from './satellite-pharmacy-xml-builder.service';
import { BigTreeMedicalRecordResult, BigTreePharmacyHttpError, BigTreePharmacyService } from './big-tree-pharmacy.service';
/** 衛星藥局請求方式*/
export enum CaseMethod{
  /** 新增 */
  Add='C1',
  /** 修改重傳 */
  Resend_Modify='UF',
  /** 還卡重傳 */
  Resend_Recard='U$',
}
enum SatellitePharmacyApp{
  /** 展望 */
  VISW='VISW',
  /** 耀聖 */
  RS='RS'
}
export type SatelliteTransferEventType = 'trySendStarted' | 'trySendFinished' | 'trySendFailed' | 'sendStarted' | 'sendFinished';
export interface SatelliteTransferEvent {
  type: SatelliteTransferEventType;
  success?: boolean;
  requestId?: number;
  patientNo?: string;
}
export interface SatelliteSendResult {
  ret: boolean;
  msg: string;
}
interface SatelliteSendQueueItem {
  hist: WholeHist;
  regIc: NHIRegIC;
  caseMethod: CaseMethod;
  resolve: (value: SatelliteSendResult) => void;
  reject: (reason?: any) => void;
}
interface PharmacyTransferContext {
  hist: WholeHist;
  regIc: NHIRegIC;
  caseMethod: CaseMethod;
  host: string;
  useBigTree: boolean;
  bigTreeApiKey: string;
  patientNo: string;
  createTime: string;
}
interface PharmacyDeliveryResult extends SatelliteSendResult {
  log: SatelliteLog;
  /** 業務拒絕不一定代表傳輸失敗，可覆寫完成事件的成功狀態。 */
  markSendFinishedSuccess?: boolean;
}
@Injectable({
  providedIn: 'root'
})
export class SatellitePharmacyServiceService {

  /** 院所具備 BIGTREE 加購模組時，改走大樹藥局交換檔。 */
  public get IsUseBigTree(): boolean {
    return !!this.getBigTreeModule();
  }

  private get BigTreeApiKey(): string {
    const module = this.getBigTreeModule();
    return module && module.DevKey ? module.DevKey : '';
  }

  enumsCodes: NumberValueTextPairBundle = null;
  hist1:HST001Params = null;
  hospId:string = '';
  private port = '7701';
  private readonly transferEventSubject = new Subject<SatelliteTransferEvent>();
  public readonly transferEvents$ = this.transferEventSubject.asObservable();
  /** 最近一次連線測試結果，供較晚建立的狀態元件初始化。 */
  public lastTrySendSuccess: boolean | null = null;
  private sendRequestSeed = 0;
  private latestSendRequestId = 0;
  private activeSendCount = 0;
  private readonly sendQueue: SatelliteSendQueueItem[] = [];
  private isProcessingSendQueue = false;
  constructor(
    private clinicData:ClinicDataService,
    private patientApi:PatientApi,
    private hcrService:HcrService,
    private regApi:RegisterApi,
    private session:SessionService,
    private clinicSessionApi:ClinicSessionApi,
    private easyNotification:EasyNotificationService,
    private logger:DebugLogService,
    private xmlBuilder:SatellitePharmacyXmlBuilder,
    private bigTreePharmacyService:BigTreePharmacyService
    ) {
  }
  private host:string = '';
  public get Host(){
      return this.host;
  }
  public useSatellite(){
    return this.session.getData('useSatellite');
  }

  public async getHost(){
    const useSatellite = this.session.getData('useSatellite');
    const SituationId = this.session.getData('SituationId');
    if(!this.host){
      if (useSatellite && (SituationId !== 0) ) {
        var sitdata = await this.getSessionData(SituationId);
        this.host  = sitdata.SatellitePhamacyIP;
      }
    }
    return this.host
  }
  public async trySend(host:string='',showNotify:boolean = true){
    this.transferEventSubject.next({ type: 'trySendStarted' });
    this.hist1 = await this.clinicData.getParam("HST001");
    if(!host){
      const useSatellite = this.session.getData('useSatellite');
      const SituationId = this.session.getData('SituationId');
      if (useSatellite && (SituationId !== 0)) {
        var sitdata = await this.getSessionData(SituationId);
        this.host = this.IsUseBigTree
          ? sitdata.SatellitePhamacyIP
          : sitdata.SatellitePhamacyIP+':'+this.port;
        if(sitdata.SatellitePhamacyIP.indexOf(':')>=0 || this.IsUseBigTree){
          this.host = sitdata.SatellitePhamacyIP;
        }
      }
      host = this.host
    }
    const pharmacyName = this.IsUseBigTree ? '藥局' : '衛星藥局';
    try{
      var ret = this.IsUseBigTree
        ? await this.bigTreePharmacyService.TrySend(host, this.BigTreeApiKey)
        : await this.hcrService.SendFromUrl('http://'+ host +'/uploadAction','test','application/xml','ascii',{
          'X-TRY':''
        });
    if(showNotify){
      if(!ret.Successed){
        this.easyNotification.showWarning(`${pharmacyName}連線測試失敗！(${host})`)
      }else{
        this.easyNotification.showInfo(`${pharmacyName}連線測試成功！(${host})`)
      }
    }

      if(!ret.Successed){
        this.transferEventSubject.next({ type: 'trySendFailed' });
      }
      this.lastTrySendSuccess = ret.Successed;
      this.transferEventSubject.next({ type: 'trySendFinished', success: ret.Successed });
      return ret;
    }catch(ex){
      this.lastTrySendSuccess = false;
      this.transferEventSubject.next({ type: 'trySendFailed' });
      this.transferEventSubject.next({ type: 'trySendFinished', success: false });
      throw ex;
    }
  }

  public async send(hist:WholeHist, regIc:NHIRegIC, caseMethod:CaseMethod): Promise<SatelliteSendResult>{
    const patientNo = this.formatPatientNo(hist.Patient.PatientNo);
    const requestId = this.markSendStarted(patientNo);
    let success = false;

    try {
      await this.resolveHospitalId();
      const context = await this.prepareTransferContext(hist, regIc, caseMethod, patientNo);
      if (!context) {
        success = true;
        return { ret: true, msg: '' };
      }

      const delivery = context.useBigTree
        ? await this.sendToBigTree(context)
        : await this.sendToSatellite(context);
      success = delivery.markSendFinishedSuccess != null
        ? delivery.markSendFinishedSuccess
        : delivery.ret;
      await this.UpdateSatelliteState(delivery.log);
      return { ret: delivery.ret, msg: delivery.msg };
    } finally {
      this.markSendFinished(requestId, success, patientNo);
    }
  }

  private formatPatientNo(patientNo: string): string {
    return patientNo.length == 10 ? patientNo.substring(3, 10) : patientNo.padStart(7, '0');
  }

  private getBigTreeModule(): { DevKey: string; Module: string } | undefined {
    const preload = this.clinicData.lastestPreloadDto;
    return preload && preload.addionModules
      ? preload.addionModules.find(module => module.Module === 'BIGTREE')
      : undefined;
  }

  private async resolveHospitalId(): Promise<void> {
    if (this.hospId) {
      return;
    }

    this.hospId = UserCache.getLoginUser().Clinic.NHICode;
    try {
      const hospIdFromSAM = (await this.hcrService.VisionApi.GetHospID()).Data;
      const testHospIds = ['7777777777', '8888888888', '9999999999'];
      if (hospIdFromSAM && !testHospIds.includes(hospIdFromSAM)) {
        this.hospId = hospIdFromSAM;
      }
    } catch {
      // SAM 無法取得時沿用登入院所代碼。
    }
  }

  private async prepareTransferContext(
    hist: WholeHist,
    regIc: NHIRegIC,
    caseMethod: CaseMethod,
    patientNo: string
  ): Promise<PharmacyTransferContext | null> {
    this.hist1 = await this.clinicData.getParam('HST001');
    const host = await this.resolvePharmacyHost();
    if (!host) {
      return null;
    }

    const transferHist = this.createTransferHist(hist);
    if (transferHist.Hist.HRxs.length === 0) {
      return null;
    }
    const bigTreeModule = this.getBigTreeModule();

    return {
      hist: transferHist,
      regIc,
      caseMethod,
      host,
      useBigTree: !!bigTreeModule,
      bigTreeApiKey: bigTreeModule && bigTreeModule.DevKey ? bigTreeModule.DevKey : '',
      patientNo,
      createTime: this.createTransferTime(new Date())
    };
  }

  private async resolvePharmacyHost(): Promise<string> {
    const useSatellite = this.session.getData('useSatellite');
    const situationId = this.session.getData('SituationId');
    if (!useSatellite || situationId === 0) {
      return '';
    }

    const situation = await this.getSessionData(situationId);
    return situation && situation.SatellitePhamacyIP
      ? situation.SatellitePhamacyIP.trim()
      : '';
  }

  private createTransferTime(now: Date): string {
    const time = now.getHours().toString().padStart(2, '0')
      + now.getMinutes().toString().padStart(2, '0')
      + now.getSeconds().toString().padStart(2, '0');
    return `${now.getFullYear() - 1911}${(now.getMonth() + 1).toString().padStart(2, '0')}${now.getDate().toString().padStart(2, '0')}${time}`;
  }

  /**
   * 套用衛星藥局既有傳送條件，並建立獨立資料，避免改寫畫面正在使用的 WholeHist。
   */
  private createTransferHist(hist: WholeHist): WholeHist {
    const configuredCodes = this.hist1 && this.hist1.SatellitePhamacyCodes
      ? this.hist1.SatellitePhamacyCodes.split(',')
        .map(item => parseInt(item, 10))
        .filter(item => !isNaN(item))
      : [];
    const typeApplyRx = configuredCodes.length > 0 ? configuredCodes : [2, 3];
    const orders = hist && hist.Hist && hist.Hist.HRxs ? hist.Hist.HRxs : [];
    const filteredOrders = orders.filter(hrx =>
      hrx.DispTP !== OrderDispensingTypeEnum.T0_Clinic && (
        typeApplyRx.includes(hrx.RxType) ||
        (hrx.SPRule == OrderSpecialRuleEnum.A9_SpecialDelivery && (hrx.RxType == 4 || hrx.RxType == 12))
      )
    );

    return {
      ...hist,
      Hist: {
        ...hist.Hist,
        HRxs: filteredOrders
      }
    } as WholeHist;
  }

  /** 將既有的新增／重傳語意轉接至大樹藥局 API。 */
  private async sendToBigTree(context: PharmacyTransferContext): Promise<PharmacyDeliveryResult> {
    const log = this.createTransferLog(context, 'json', '', context.host);
    try {
      const result = await this.executeBigTreeRequest(context);
      log.IsSuccess = true;
      log.XmlContent = JSON.stringify(result);
      return { ret: true, msg: '', log };
    } catch (error) {
      const bigTreeError = error instanceof BigTreePharmacyHttpError ? error : null;
      const isAlreadyDispensed = context.caseMethod !== CaseMethod.Add
        && this.isBigTreeAlreadyDispensedError(error);
      const msg = isAlreadyDispensed
        ? '此筆病歷已包藥，不可重傳'
        : this.getErrorMessage(error);
      log.ErrMsg = msg;
      log.XmlContent = bigTreeError && bigTreeError.responseBody != null
        ? this.getResponseMessage(bigTreeError.responseBody)
        : '';
      return {
        ret: false,
        msg,
        log,
        markSendFinishedSuccess: isAlreadyDispensed
      };
    }
  }

  /** Update 找不到既有 KDT 時，改以 Add 完成補傳。 */
  private async executeBigTreeRequest(context: PharmacyTransferContext): Promise<BigTreeMedicalRecordResult> {
    if (context.caseMethod === CaseMethod.Add) {
      return await this.bigTreePharmacyService.Send(context.hist, context.host, context.bigTreeApiKey);
    }

    try {
      return await this.bigTreePharmacyService.Update(context.hist, context.host, context.bigTreeApiKey);
    } catch (error) {
      if (!this.isBigTreeNotFoundError(error)) {
        throw error;
      }
      return await this.bigTreePharmacyService.Send(context.hist, context.host, context.bigTreeApiKey);
    }
  }

  private isBigTreeNotFoundError(error: any): boolean {
    if (!(error instanceof BigTreePharmacyHttpError)) {
      return false;
    }

    const statusCode = String(error.statusCode).toLowerCase();
    return statusCode === '404' || statusCode === 'notfound';
  }

  private isBigTreeAlreadyDispensedError(error: any): boolean {
    if (!(error instanceof BigTreePharmacyHttpError)) {
      return false;
    }

    return error.code === 'RECORD_ALREADY_PROCESSING'
      || String(error.upStatus).trim() === '2';
  }

  /** 建立並傳送舊衛星藥局 XML。 */
  private async sendToSatellite(context: PharmacyTransferContext): Promise<PharmacyDeliveryResult> {
    this.enumsCodes = await this.clinicData.getEnum(['Sex', 'Blood', 'RH']);
    const jailInfo = await this.parseJailInfo(context.hist);
    const originalXml = await this.builXml(
      context.hist,
      context.regIc,
      SatellitePharmacyApp.VISW,
      context.caseMethod,
      jailInfo
    );
    const encodedXml = this.strToHex(originalXml);
    this.host = context.host.indexOf(':') >= 0 ? context.host : `${context.host}:${this.port}`;
    const url = `http://${this.host}/uploadAction`;
    const log = this.createTransferLog(context, 'xml', originalXml, this.host);

    try {
      const response = await this.hcrService.SendFromUrl(url, encodedXml, 'application/xml', 'ascii', {
        'X-Format': 'vis:6inary',
        'X-Filename': log.FileName
      }, true);
      const msg = this.getResponseMessage(response.Returns);
      log.IsSuccess = response.Successed;
      log.ErrMsg = msg;
      return response.Successed
        ? { ret: true, msg: '', log }
        : { ret: false, msg, log };
    } catch (error) {
      const msg = this.getErrorMessage(error);
      log.ErrMsg = msg;
      return { ret: false, msg, log };
    }
  }

  /** 從病歷延伸欄位解析監獄資訊。 */
  private async parseJailInfo(hist: WholeHist): Promise<JailInfo> {
    const jailInfo: JailInfo = {
      JailHouse: null,
      JailAddressCode: '',
      JailName: '',
      PensonalCode: null
    };
    const extension = hist.Hist.SPExtension;
    const match = extension && extension.match(/\[JA=(.*?)\]/);
    if (!match) {
      return jailInfo;
    }

    match[1].split(';').forEach(pair => {
      const values = pair.trim().split(':');
      const key = values[0] ? values[0].toUpperCase() : '';
      const value = values[1];
      switch (key) {
        case 'JAILHOUSE':
          jailInfo.JailHouse = value;
          break;
        case 'JAILADDRESSCODE':
          jailInfo.JailAddressCode = value;
          break;
        case 'PERSONALCODE':
          jailInfo.PensonalCode = value;
          break;
      }
    });

    if (jailInfo.JailAddressCode) {
      const jailList = (await this.clinicData.getSystemCodes(['F0040']))['F0040'];
      const jail = jailList && jailList.find(item => item.value == jailInfo.JailAddressCode);
      if (jail) {
        jailInfo.JailName = jail.text;
      }
    }
    return jailInfo;
  }

  private createTransferLog(
    context: PharmacyTransferContext,
    fileExtension: 'xml' | 'json',
    content: string,
    host: string
  ): SatelliteLog {
    return {
      RegId: context.hist.Register.Id,
      IsSuccess: false,
      ErrMsg: '',
      SendTime: new Date(),
      FileName: `${this.hospId}-${context.patientNo + context.createTime}.${fileExtension}`,
      XmlContent: content,
      Host: host
    };
  }

  private getResponseMessage(value: any): string {
    const response = value && value.responseBody != null ? value.responseBody : value;
    if (response == null) {
      return '';
    }
    return typeof response === 'string' ? response : JSON.stringify(response);
  }

  private getErrorMessage(error: any): string {
    return error && error.message ? error.message : String(error);
  }

  private markSendStarted(patientNo: string): number {
    const requestId = ++this.sendRequestSeed;
    this.latestSendRequestId = requestId;
    this.activeSendCount++;
    this.transferEventSubject.next({ type: 'sendStarted', requestId, patientNo });
    return requestId;
  }

  /**
   * 佇列版送出：同時間多次呼叫時，會依呼叫順序逐筆送出。
   */
  public sendWithQueue(hist: WholeHist, regIc: NHIRegIC, caseMethod: CaseMethod): Promise<SatelliteSendResult> {
    return new Promise<SatelliteSendResult>((resolve, reject) => {
      this.sendQueue.push({
        hist,
        regIc,
        caseMethod,
        resolve,
        reject
      });
      void this.processSendQueue();
    });
  }

  private async processSendQueue(): Promise<void> {
    if (this.isProcessingSendQueue) {
      return;
    }
    this.isProcessingSendQueue = true;
    this.regApi.api.enableLoader = false;
    this.patientApi.apiService.enableLoader = false;
    try {
      while (this.sendQueue.length > 0) {
        const item = this.sendQueue.shift();
        if (!item) {
          continue;
        }
        try {
          const result = await this.send(item.hist, item.regIc, item.caseMethod);
          
      
          if (!result.ret) {
            this.easyNotification.showError('衛星藥局轉送失敗: ' + result.msg);
            this.logger.ClientLog('Error', false, '衛星藥局轉送失敗: ' + result.msg);
          } else {
            this.logger.ClientLog('Info', true, '衛星藥局轉送完成');
          }
          item.resolve(result);
        } catch (error) {
          item.reject(error);
          // console.log(ex);
          this.easyNotification.showError('衛星藥局轉送失敗');
          this.logger.ClientLog('Error', false, '衛星藥局轉送失敗: ' + (JSON.stringify(error) ?? '不明的錯誤'));
        }
        
      }
    } finally {
      this.isProcessingSendQueue = false;
      // 避免 finally 期間又有新項目進來，補一次保險啟動。
      if (this.sendQueue.length > 0) {
        void this.processSendQueue();
      }
      this.regApi.api.enableLoader = true;
      this.patientApi.apiService.enableLoader = true;
    }
  }
  private markSendFinished(requestId: number, success: boolean, patientNo: string): void {
    this.activeSendCount = Math.max(0, this.activeSendCount - 1);
    if (requestId !== this.latestSendRequestId || this.activeSendCount > 0) {
      return;
    }
    this.transferEventSubject.next({ type: 'sendFinished', requestId, success, patientNo });
  }
  private async UpdateSatelliteState(log:SatelliteLog){
    await this.regApi.UpdateSatelliteState(log);
  }
  private strToHex(str) {
    try {
        const big5Buffer = encode(str, 'big5');
        const hexString = big5Buffer.toString('hex');
        return hexString;

        // const bytes = new Uint8Array(big5Buffer)
        // return Array.from(bytes)
        // .map(byte => byte.toString(16).padStart(2, '0')) // 每個字節轉成兩位16進位
        // .join(''); // 將所有字串連接成一個完整的字串
    } catch (er) {
    }
  }
  public async builXml(hist:WholeHist,regIc:NHIRegIC,app:SatellitePharmacyApp,caseMethod:CaseMethod,jailInfo:JailInfo){
    const [patient, diagnosisOptions, prescriptionOptions] = await Promise.all([
      this.patientApi.Get(hist.Patient.Id),
      this.clinicData.GetDxOption(),
      this.clinicData.GetRxOption()
    ]);

    return this.xmlBuilder.build({
      hist,
      regIc,
      patient,
      app,
      caseMethod,
      jailInfo,
      hospId: this.hospId,
      histParams: this.hist1,
      enumCodes: this.enumsCodes,
      diagnosisOptions,
      prescriptionOptions
    });
  }

  private async getSessionData(SituationId:number){
    if(FunctionEnable.EnableClientAdvCache){
      return await this.clinicData.GetClinicSession(SituationId);
    }else{
      return await this.clinicSessionApi.Get(SituationId);
    }
  }

}
